import React from 'react';
import './Detail.less';
import HwzComponent from '../../common/component/HwzComponent';
import { Button, Space, Tag, Tooltip } from 'antd'; // 增加 Tooltip
import InfoCell from '../widget/InfoCell';
import User, { AllowedDeviceType } from '../../common/model/user/User';
import Moon from '../../common/model/global/Moon';
import DateUtil from '../../common/util/DateUtil';
import HwzTitle from '../widget/HwzTitle';
import HwzContentCard from '../widget/HwzContentCard';
import { Link, RouteComponentProps } from 'react-router-dom';
import ImagePreviewer from '../widget/previewer/ImagePreviewer';
import { UserRole, UserRoleMap } from '../../common/model/user/UserRole';
import FileUtil from '../../common/util/FileUtil';
import { UserStatus, UserStatusMap } from '../../common/model/user/UserStatus';
import BrowserUtil from '../../common/util/BrowserUtil';
import SingleTextModal from '../widget/SingleTextModal';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import ChangePasswordModal from './widget/ChangePasswordModal';
import {
  EditOutlined,
  UnlockOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons';
import TransfigurationModal from './widget/TransfigurationModal';
import { FileSyncOutlined, StopOutlined } from '@ant-design/icons/lib';
import Lang from '../../common/model/global/Lang';
import Sun from '../../common/model/global/Sun';

interface RouteParam {
  uuid: string;
}

interface IProps extends RouteComponentProps<RouteParam> {}

interface IState {}

export default class Detail extends HwzComponent<IProps, IState> {
  //登录的那个用户
  user: User = Moon.getSingleton().user;

  //当前页面正在编辑的用户
  currentUser: User = new User(this);

  //sync loading.
  syncLoading: boolean = false;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    let that = this;
    let match = this.props.match;
    this.currentUser.uuid = match.params.uuid;
    this.currentUser.httpDetail();
  }

  resetPassword() {
    let that = this;

    SingleTextModal.open(
      Lang.t('user.enterNewPassword'),
      '',
      function (text: string) {
        that.currentUser.httpResetPassword(text, function (response: any) {
          MessageBoxUtil.success(Lang.t('operationSuccess'));
        });
      }
    );
  }

  transfiguration() {
    let user: User = this.user;
    let currentUser: User = this.currentUser;
    TransfigurationModal.open(currentUser);
  }

  toggleStatus() {
    let that = this;
    let user: User = this.user;
    let currentUser: User = this.currentUser;
    currentUser.httpToggleStatus(function () {
      MessageBoxUtil.success(Lang.t('operationSuccess'));
      that.updateUI();
    });
  }

  syncPhysics() {
    let that = this;
    let user: User = this.user;
    let currentUser: User = this.currentUser;
    this.syncLoading = true;
    currentUser.httpScan(
      function () {
        MessageBoxUtil.success(Lang.t('operationSuccess'));
        that.updateUI();
      },
      null,
      function () {
        that.syncLoading = false;
        that.updateUI();
      }
    );
  }

  changePassword() {
    let user: User = this.user;
    let currentUser: User = this.currentUser;
    ChangePasswordModal.open(currentUser, function () {
      MessageBoxUtil.success(Lang.t('operationSuccess'));
    });
  }

  // 检查设备类型是否在允许的设备列表中
  hasDeviceType(deviceType: AllowedDeviceType): boolean {
    return this.currentUser.allowedDevices?.includes(deviceType) || false;
  }

  render() {
    const user: User = this.user;
    const currentUser: User = this.currentUser;

    const handles = (
      <Space
        className={`handles ${
          Sun.getSingleton().isMobile ? 'handles-mobile' : ''
        }`}
      >
        {user.role === UserRole.ADMINISTRATOR && (
          <Button
            type="primary"
            icon={<UnlockOutlined />}
            onClick={this.resetPassword.bind(this)}
          >
            {Lang.t('user.resetPassword')}
          </Button>
        )}

        {currentUser.uuid === user.uuid && (
          <Button
            type="primary"
            onClick={this.changePassword.bind(this)}
            icon={<UnlockOutlined />}
          >
            {Lang.t('user.changePassword')}
          </Button>
        )}

        {user.role === UserRole.ADMINISTRATOR &&
          currentUser.uuid !== user.uuid && (
            <Button
              type="primary"
              danger={currentUser.status === UserStatus.OK}
              icon={<StopOutlined />}
              onClick={this.toggleStatus.bind(this)}
            >
              {currentUser.status === UserStatus.OK
                ? Lang.t('user.disable')
                : Lang.t('user.active')}
            </Button>
          )}

        {user.role === UserRole.ADMINISTRATOR && (
          <Button
            type="primary"
            icon={<FileSyncOutlined />}
            loading={this.syncLoading}
            onClick={this.syncPhysics.bind(this)}
          >
            {Lang.t('user.sync')}
          </Button>
        )}
      </Space>
    );

    // 获取授权截止日期的显示内容
    const renderExpirationDate = () => {
      if (!currentUser.expirationDate) {
        return <Tag color="green">{Lang.t('user.permanent', '永久')}</Tag>;
      }
      const dateStr = DateUtil.simpleDate(currentUser.expirationDate);
      if (currentUser.isExpired && currentUser.isExpired()) {
        return (
          <Tooltip title={Lang.t('user.expiredTip', '账号已过期，请续期')}>
            <Tag color="red">{dateStr}</Tag>
            <Tag color="red" style={{ marginLeft: 8 }}>
              {Lang.t('user.expired', '已过期')}
            </Tag>
          </Tooltip>
        );
      }
      return <Tag color="cyan">{dateStr}</Tag>;
    };

    return (
      <div className="page-user-detail">
        <HwzTitle name={Lang.t('user.profile')}>
          {!Sun.getSingleton().isMobile && handles}
        </HwzTitle>
        {Sun.getSingleton().isMobile && handles}

        <HwzContentCard loading={currentUser.detailLoading}>
          <div className="text-center mv20">
            <img
              className="avatar-large"
              alt="avatar"
              src={currentUser.getAvatarUrl()}
              onClick={() => {
                ImagePreviewer.showSinglePhoto(currentUser.getAvatarUrl(true));
              }}
            />
            <div className="f24">{currentUser.username}</div>
          </div>

          <InfoCell name={Lang.t('user.role')}>
            <Tag color={UserRoleMap[currentUser.role].color}>
              {UserRoleMap[currentUser.role].name}
            </Tag>
          </InfoCell>

          <InfoCell name={Lang.t('user.singleFileSizeLimit')}>
            {currentUser.space?.getHumanizeSizeLimit()}
          </InfoCell>

          <InfoCell name={Lang.t('user.totalFileSizeLimit')}>
            {currentUser.space?.getHumanizeTotalSizeLimit()}
          </InfoCell>

          <InfoCell name={Lang.t('user.totalFileSize')}>
            {currentUser.space?.getHumanizeTotalSize()}
          </InfoCell>

          <InfoCell name={Lang.t('user.status')}>
            <Tag color={UserStatusMap[currentUser.status].color}>
              {UserStatusMap[currentUser.status].name}
            </Tag>
          </InfoCell>

          {/* 新增：授权截止日期 */}
          <InfoCell name={Lang.t('user.expirationDate', '授权截止日期')}>
            {renderExpirationDate()}
          </InfoCell>

          {/* 用户限制类型显示 */}
          <InfoCell name={Lang.t('user.userLimitType')}>
            <Space direction="vertical" size="small">
              <Tag color={currentUser.userLimitType === 'READ_WRITE' ? 'green' : 
                         currentUser.userLimitType === 'UPLOAD_PREVIEW' ? 'orange' : 'blue'}>
                {currentUser.getUserLimitTypeDisplayName()}
              </Tag>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {currentUser.getUserLimitTypeDescription()}
              </div>
            </Space>
          </InfoCell>

          {/* 部门信息显示 */}
          {currentUser.deptShortName && (
            <InfoCell name={Lang.t('user.department')}>
              <Tag color="geekblue">{currentUser.getDeptDisplayName()}</Tag>
            </InfoCell>
          )}

          {/* 分享设置状态显示 */}
          <InfoCell name={Lang.t('user.shareSettings')}>
            <Space direction="vertical" size="small">
              <div>
                <Tag color={currentUser.disableShare ? 'red' : 'green'}>
                  {currentUser.disableShare ? Lang.t('user.disableShare') : Lang.t('user.shareEnabled')}
                </Tag>
                <span style={{ marginLeft: 8, fontSize: '12px', color: '#666' }}>
                  {Lang.t('user.disableShareHint')}
                </span>
              </div>
              {!currentUser.disableShare && (
                <div>
                  <Tag color={currentUser.disablePublicShare ? 'orange' : 'blue'}>
                    {currentUser.disablePublicShare ? Lang.t('user.disablePublicShare') : Lang.t('user.publicShareEnabled')}
                  </Tag>
                  <span style={{ marginLeft: 8, fontSize: '12px', color: '#666' }}>
                    {currentUser.disablePublicShare 
                      ? Lang.t('user.disablePublicShareHint') 
                      : Lang.t('user.publicShareEnabledHint')}
                  </span>
                </div>
              )}
            </Space>
          </InfoCell>

          {/* 设备权限显示 */}
          {currentUser.allowedDevices && currentUser.allowedDevices.length > 0 && (
            <InfoCell name={Lang.t('user.allowedDevices')}>
              <Space wrap>
                {this.hasDeviceType(AllowedDeviceType.WEB) && (
                  <Tag color="blue">{Lang.t('user.webClient')}</Tag>
                )}
                {this.hasDeviceType(AllowedDeviceType.PCAPP) && (
                  <Tag color="green">{Lang.t('user.pcClient')}</Tag>
                )}
                {this.hasDeviceType(AllowedDeviceType.MOBILE) && (
                  <Tag color="purple">{Lang.t('user.mobileClient')}</Tag>
                )}
              </Space>
            </InfoCell>
          )}

          {/* 绑定终端特征显示 */}
          <InfoCell name={Lang.t('user.bindDeviceFeature')}>
            <Space direction="vertical" size="small">
              <div>
                <Tag color={currentUser.bindWebFeature ? 'orange' : 'default'}>
                  {Lang.t('user.bindWebFeature')}: {currentUser.bindWebFeature ? Lang.t('user.enabled') : Lang.t('user.disabled')}
                </Tag>
                {currentUser.bindWebFeature && this.hasDeviceType(AllowedDeviceType.WEB) && (
                  <span style={{ marginLeft: 8, fontSize: '12px', color: '#666' }}>
                    {Lang.t('user.bindWebFeatureTip')}
                  </span>
                )}
              </div>
              <div>
                <Tag color={currentUser.bindPcFeature ? 'orange' : 'default'}>
                  {Lang.t('user.bindPcFeature')}: {currentUser.bindPcFeature ? Lang.t('user.enabled') : Lang.t('user.disabled')}
                </Tag>
                {currentUser.bindPcFeature && this.hasDeviceType(AllowedDeviceType.PCAPP) && (
                  <span style={{ marginLeft: 8, fontSize: '12px', color: '#666' }}>
                    {Lang.t('user.bindPcFeatureTip')}
                  </span>
                )}
              </div>
            </Space>
          </InfoCell>

          {/* IP范围限制显示 */}
          <InfoCell name={Lang.t('user.allowedIpRange')}>
            <Space direction="vertical" size="small">
              {/* Web端IP范围显示 */}
              {this.hasDeviceType(AllowedDeviceType.WEB) && (
                <div>
                  <span style={{ fontWeight: 'bold' }}>{Lang.t('user.webAllowedIpRange')}: </span>
                  {currentUser.webAllowedIpRange || currentUser.allowedIpRange ? (
                    <Tag color="cyan">{currentUser.webAllowedIpRange || currentUser.allowedIpRange}</Tag>
                  ) : (
                    <Tag color="default">{Lang.t('user.noIpRangeSet')}</Tag>
                  )}
                </div>
              )}
              
              {/* PC端IP范围显示 */}
              {this.hasDeviceType(AllowedDeviceType.PCAPP) && (
                <div>
                  <span style={{ fontWeight: 'bold' }}>{Lang.t('user.pcAllowedIpRange')}: </span>
                  {currentUser.pcAllowedIpRange || currentUser.allowedIpRange ? (
                    <Tag color="cyan">{currentUser.pcAllowedIpRange || currentUser.allowedIpRange}</Tag>
                  ) : (
                    <Tag color="default">{Lang.t('user.noIpRangeSet')}</Tag>
                  )}
                </div>
              )}
            </Space>
          </InfoCell>

          <InfoCell name={Lang.t('user.lastLoginIp')}>
            {currentUser.lastIp}
          </InfoCell>

          <InfoCell name={Lang.t('user.lastLoginTime')}>
            {DateUtil.simpleDateTime(currentUser.lastTime)}
          </InfoCell>

          <InfoCell name={Lang.t('user.webdavLink')}>
            <div>
              <div>{BrowserUtil.fullHost() + '/api/dav'}</div>
              <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                {Lang.t('user.webdavHint')}
              </div>
            </div>
          </InfoCell>

          {currentUser.role === UserRole.ADMINISTRATOR && (
            <InfoCell name={Lang.t('user.docLink')}>
              <a
                className="f14"
                href="http://www.hanweizhe.net"
                target="_blank"
              >
                http://www.hanweizhe.net
              </a>
            </InfoCell>
          )}
        </HwzContentCard>
      </div>
    );
  }
}